// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestorAccountResponse
 */
export interface IInvestorAccountResponse {
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountResponse
     */
    investor_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountResponse
     */
    balance?: number | null;
}

/**
 * Check if a given object implements the IInvestorAccountResponse interface.
 */
export function instanceOfIInvestorAccountResponse(value: object): value is IInvestorAccountResponse {
    return true;
}

export function IInvestorAccountResponseFromJSON(json: any): IInvestorAccountResponse {
    return IInvestorAccountResponseFromJSONTyped(json, false);
}

export function IInvestorAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestorAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'investor_id': json['investor_id'] == null ? undefined : json['investor_id'],
        'balance': json['balance'] == null ? undefined : json['balance'],
    };
}

export function IInvestorAccountResponseToJSON(json: any): IInvestorAccountResponse {
    return IInvestorAccountResponseToJSONTyped(json, false);
}

export function IInvestorAccountResponseToJSONTyped(value?: IInvestorAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investor_id': value['investor_id'],
        'balance': value['balance'],
    };
}

